/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import axios, { CancelTokenSource } from 'axios'
import moment from 'moment'
import ToastMessagesNormalizer from 'normalizer/ToastMessagesNormalizer'
import MessagesTableNormalizer from 'normalizer/MessagesTableNormalizer'

import ROUTES from 'utils/ROUTES'
import OrganizationEntity from 'utils/__interfaces/Administrations/Organizations/OrganizationEntity'
import {
  Message,
  ToastMessage,
} from 'utils/__interfaces/SuperAdministration/Message'
import getFormatedMessageUsers from 'utils/SuperAdministration/Messages/message-utils'
import { TIME_OUT_TABLE } from 'utils/__consts/Common/Table'
import isCancel from 'utils/Common/api-utils'
import { getMemberData } from './hydra-services'
import flatFilter from '../utils/Filters/filter-utils'
import ContractEntity from '../utils/__interfaces/Perimeter/ContractEntity'

let cancelToken: CancelTokenSource
const labelsToApiFields: { [key: string]: string } = {
  'Date de publication': 'createdAt',
  'Date d’expiration': 'expireAt',
  Status: 'statut',
  Message: 'messagetext',
  Source: 'source',
}

export async function getMessageTable(
  perPage: number,
  page: number,
  organisation: OrganizationEntity[] = [],
  contracts: ContractEntity[] = [],
  sortTable: any,
  filters: { [key: string]: any | any[] },
  history: any
): Promise<{
  results: Message[]
  pageCount: number
  isTimeOut: boolean
}> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages`
  let listOfMessage: Message[] = []
  const params = new URLSearchParams()
  params.append(`page`, page.toString())
  params.append(`perPage`, perPage.toString())

  organisation.forEach((org) => {
    params.append(`idOrganisation[]`, org.id)
  })
  contracts.forEach((contract) => {
    params.append(`contratId[]`, contract.id)
  })
  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(`order[${labelsToApiFields[key]}]`, sortTable[key])
    })
  }

  flatFilter(params, filters)

  if (cancelToken !== undefined) {
    cancelToken.cancel('Operation canceled due to new request.')
  }

  cancelToken = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
      timeout: TIME_OUT_TABLE,
    })
    if (resp?.data) {
      // Result Normalization
      listOfMessage = MessagesTableNormalizer.normalize(
        getMemberData(resp.data)
      )

      const totalItems = parseInt(resp.data['hydra:totalItems'], 10)
      return {
        results: [...listOfMessage],
        pageCount: Math.ceil(totalItems / perPage),
        isTimeOut: false,
      }
    }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        pageCount: 0,
        results: [],
        isTimeOut: true,
      })
    }
    if (isCancel(err)) {
      return Promise.resolve({ pageCount: 0, results: err, isTimeOut: false })
    }
    history.push(ROUTES.TechnicalError)
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({ pageCount: 0, results: [], isTimeOut: false })
}

export async function patchBannerMessage(
  messageId: string,
  state: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages/${messageId}`

  let status = 400

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {
        statut: state,
      },
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}

export async function postMessageContrats(
  messagetext: string,
  expireAt: Date,
  contrats: ContractEntity[]
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages`
  let status = 400
  const contratsIds = contrats?.map((contrat) => {
    return { contratId: contrat.id }
  })
  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: {
        messagetext,
        expireAt,
        contrats: contratsIds,
      },
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}

export async function postMessageUsers(
  messageText: string,
  expireAt: Date,
  usersId: string[]
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages`

  let status = 400

  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: getFormatedMessageUsers(messageText, expireAt, usersId),
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}

export async function postMessageSource(
  messagetext: string,
  expireAt: Date,
  source: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages`

  let status = 400

  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: {
        messagetext,
        expireAt,
        source,
      },
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}

// return the list of messages to show to the connected user
export async function getToastMessages() {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages`
  const params = new URLSearchParams()
  let result: ToastMessage[] = []
  params.append(`page`, '1')
  params.append(`perPage`, '3')
  params.append(`order[createdAt]`, 'DESC')
  params.append(`statut`, 'activated')
  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
    })
    const res = getMemberData(resp?.data)
    if (res.length)
      result = ToastMessagesNormalizer.normalize(getMemberData(resp.data))
  } catch (err) {
    throw new Error(err)
  }
  return result
}

export async function getMessage(idMessage: string): Promise<Message> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages/${idMessage}`
  const res = {
    id: '',
    messagetext: '',
    statut: '',
    type: '',
    source: '',
    contracts: [],
    users: [],
  }
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })
    if (resp?.data) {
      return MessagesTableNormalizer.normalizeSingle(resp.data)
    }
  } catch (err) {
    throw new Error(err)
  }
  return res
}

export async function patchMessageContrats(
  messageId: string,
  messagetext: string,
  expireAt: Date,
  contrats: ContractEntity[]
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages/${messageId}`
  let data: any
  let status = 400
  const contratsIds = contrats?.map((contrat) => {
    return { contratId: contrat.id }
  })
  data = {
    messagetext,
    expireAt,
  }
  if (contratsIds.length > 0) {
    data = {
      messagetext,
      expireAt,
      contrats: contratsIds,
    }
  }
  if (moment(expireAt).isAfter(moment())) {
    data = {
      messagetext,
      expireAt,
      contrats: contratsIds,
      statut: 'activated',
    }
  }
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}

export async function removeMessageContratLink(
  contratId: string,
  messageId: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/asso_messages_contrats/contratId=${contratId};message=${messageId}`
  let status = 400
  try {
    const resp = await axios({
      method: 'DELETE',
      url,
    })

    status = resp?.status
  } catch (err) {
    throw new Error(`Erreur : ${err}`)
  }
  return status
}

export async function callAPIRemoveMessageContrat(
  contratsId: string[],
  messageId: string
) {
  for (const item of contratsId) {
    await removeMessageContratLink(item, messageId)
  }
}

export async function patchMessageUsers(
  messageId: string,
  messageText: string,
  expireAt: Date,
  usersId: string[]
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages/${messageId}`
  let data: any
  let status = 400
  data = {
    messagetext: messageText,
    expireAt: moment(expireAt).format('YYYY-MM-DD'),
  }
  if (moment(expireAt).isAfter(moment())) {
    data = {
      messagetext: messageText,
      expireAt: moment(expireAt).format('YYYY-MM-DD'),
      statut: 'activated',
    }
  }
  if (usersId.length > 0) {
    data = getFormatedMessageUsers(messageText, expireAt, usersId)
  }
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}
export async function removeMessageUserLink(
  userId: string,
  messageId: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/asso_messages_users/user=${userId};message=${messageId}`
  let status = 400
  try {
    const resp = await axios({
      method: 'DELETE',
      url,
    })

    status = resp?.status
  } catch (err) {
    throw new Error(`Erreur : ${err}`)
  }
  return status
}

export async function callAPIRemoveMessageUser(
  usersId: string[],
  messageId: string
) {
  for (const item of usersId) {
    await removeMessageUserLink(item, messageId)
  }
}

export async function patchMessageSource(
  messageId: string,
  messagetext: string,
  expireAt: Date,
  source: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/messages/${messageId}`
  let data: any
  let status = 400
  data = {
    messagetext,
    expireAt,
    source,
  }
  if (moment(expireAt).isAfter(moment())) {
    data = {
      messagetext,
      expireAt,
      source,
      statut: 'activated',
    }
  }
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })
    status = resp?.status
  } catch (err) {
    throw new Error(err)
  }
  return status
}
